import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import Typography from '@material-ui/core/Typography';
import MissingValue from './MissingValue';
import Icon from '../core/Icon';
/**
 * @param {import('./types').TextFormatter} props
 **/

var TextFormatter = function TextFormatter(_ref) {
  var value = _ref.value,
      icon = _ref.icon,
      fallback = _ref.fallback,
      title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["value", "icon", "fallback", "title"]);

  var hasValue = MissingValue.isSpecified(value, rest);
  if (!hasValue) return fallback;
  var titleVal = undefined;
  if (title === true) titleVal = value.toString();else if (typeof title === 'string') titleVal = title;
  return React.createElement(Typography, Object.assign({
    color: "inherit",
    title: titleVal
  }, rest), icon && React.createElement(Icon, {
    style: {
      fontSize: '1rem'
    },
    type: icon
  }), value);
};

TextFormatter.defaultProps = {
  fallback: React.createElement(MissingValue, null),
  title: true
};
export default TextFormatter;